var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, EventEmitter } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { LOCAL_VAR } from '@app/core/constants';
import { AgentsService } from '@app/core/service/agents.service';
import { DealsService } from '@app/core/service/deals.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
var SrpMinMaxFormComponent = /** @class */ (function () {
    function SrpMinMaxFormComponent(activeModal, formBuilder, toastrService, authenticationService, dealsService, agentsService) {
        this.activeModal = activeModal;
        this.formBuilder = formBuilder;
        this.toastrService = toastrService;
        this.authenticationService = authenticationService;
        this.dealsService = dealsService;
        this.agentsService = agentsService;
        this.dealId = '';
        this.product = '';
        this.onSubmitStepChange = new EventEmitter();
        this.flNotSelected = false;
        this.months = Array.from({ length: 12 }, function (_, i) { return "Month " + (i + 1); });
        this.services = Array.from({ length: 10 }, function (_, i) { return "Month " + (i + 1); });
        this.agentName = '';
        this.proInfo = '';
        this.agent = null;
        this.products = null;
        this.currencyOptions = {
            prefix: '$ ',
            thousands: ',',
            decimal: '.',
            precision: 0,
            allowNegative: false
        };
        this.user = this.authenticationService.credentials.user;
        this.dealData = this.dealsService.dealData;
        this.agent = localStorage.getItem(LOCAL_VAR.selectedAgent);
        this.agent = JSON.parse(this.agent);
    }
    SrpMinMaxFormComponent.prototype.ngOnInit = function () {
        if (this.dealData.SRPForm && this.dealData.SRPForm[this.product]) {
            this.SRPData = this.dealData.SRPForm[this.product];
        }
        if (this.dealData.state != 'FL')
            this.flNotSelected = true;
        this.createForm();
        if (this.dealData.agencyId) {
            this.getAgencyList();
        }
        this.getSelectedProducts();
    };
    SrpMinMaxFormComponent.prototype.getAgencyList = function () {
        var _this = this;
        this.isLoading = true;
        this.agentsService
            .getAgencyList()
            .pipe(finalize(function () {
            _this.isLoading = false;
        }))
            .subscribe(function (response) {
            response.records.forEach(function (agency) {
                if (_this.dealData.agencyId === agency._id) {
                    _this.agentName = agency.agencyname;
                }
            });
        });
        // console.log('333333');
    };
    SrpMinMaxFormComponent.prototype.getSelectedProducts = function () {
        var _this = this;
        this.dealsService
            .getDealSelectedProducts(this.agent._id, this.dealId)
            .pipe(finalize(function () {
            // this.isProductLoading = false;
        }))
            .subscribe(function (response) {
            if (response) {
                // this.products= response;
                var currentProduct_1 = 'DOWC';
                var data_1 = [];
                var incentive_1 = _this.dealData.SRPForm && _this.dealData.SRPForm.productMinMax ? _this.dealData.SRPForm.productMinMax : [];
                $.each(response, function (index, value) {
                    var status = true;
                    $.each(incentive_1, function (index, val) {
                        if (currentProduct_1 == value.category && val.category == value.category && val.slug == value.slug) {
                            status = false;
                            data_1.push(val);
                            return false;
                        }
                    });
                    if (status) {
                        data_1.push(value);
                    }
                });
                _this.products = data_1.filter(function (item) {
                    return item.category == currentProduct_1;
                });
                _this.formControlsValueChanges();
            }
        });
    };
    SrpMinMaxFormComponent.prototype.createForm = function () {
        var _this = this;
        this.SRPCreateFrom = this.formBuilder.group({
            type: [this.dealData.SRPForm ? this.dealData.SRPForm.type : '', [Validators.required]],
            mode: [this.dealData.SRPForm ? this.dealData.SRPForm.mode : '', [Validators.required]],
            productMinMax: this.formBuilder.array([]),
        });
        if (this.dealData.SRPForm && this.dealData.SRPForm.type) {
            this.updateCurrencyPrefix(this.dealData.SRPForm.type);
        }
        if (this.dealData.SRPForm && this.dealData.SRPForm.mode) {
            this.updateMinMaxValidators();
        }
        this.SRPCreateFrom.get('type').valueChanges.subscribe(function (typeValue) {
            _this.updateCurrencyPrefix(typeValue);
        });
        this.SRPCreateFrom.get('mode').valueChanges.subscribe(function (typeValue) {
            _this.updateMinMaxValidators();
        });
    };
    SrpMinMaxFormComponent.prototype.formControlsValueChanges = function () {
        var _this = this;
        this.minMaxProducts = this.SRPCreateFrom.get('productMinMax');
        this.products.forEach(function (product) {
            _this.minMaxProducts.push(_this.createProductForm(product));
        });
    };
    Object.defineProperty(SrpMinMaxFormComponent.prototype, "productMinMaxControls", {
        get: function () {
            return this.SRPCreateFrom.get('productMinMax').controls;
        },
        enumerable: true,
        configurable: true
    });
    SrpMinMaxFormComponent.prototype.updateCurrencyPrefix = function (type) {
        var prefix = type === 'percentage' ? '% ' : '$ ';
        this.currencyOptions = __assign({}, this.currencyOptions, { prefix: prefix });
    };
    SrpMinMaxFormComponent.prototype.updateMinMaxValidators = function () {
        var _this = this;
        var productMinMaxArray = this.SRPCreateFrom.get('productMinMax');
        productMinMaxArray.controls.forEach(function (control) {
            control.setValidators(_this.minMaxValidator());
            control.updateValueAndValidity();
        });
    };
    SrpMinMaxFormComponent.prototype.changeValidator = function () {
    };
    SrpMinMaxFormComponent.prototype.createProductForm = function (product) {
        var productname = product.name;
        if (product.slug.indexOf('other') > -1 &&
            product.value) {
            productname =
                productname +
                    ' : ' +
                    product.value;
        }
        var group = this.formBuilder.group({
            name: productname,
            slug: product.slug,
            category: [product && product.category ? product.category : 'DOWC'],
            srp: [product && product.srp ? product.srp : 0],
            enableMinMax: [product && product.enableMinMax && this.flNotSelected ? true : false],
            min: [product && product.min && this.flNotSelected ? product.min : null],
            max: [product && product.max && this.flNotSelected ? product.max : null]
        });
        group.setValidators(this.minMaxValidator());
        return group;
    };
    SrpMinMaxFormComponent.prototype.minMaxValidator = function () {
        var mode = this.SRPCreateFrom.get('mode').value;
        return function (group) {
            var srp = group.get('srp').value ? group.get('srp').value : 0;
            var min = group.get('min').value ? group.get('min').value : 0;
            var max = group.get('max').value ? group.get('max').value : 0;
            var enableMinMax = group.get('enableMinMax').value ? true : false;
            if (enableMinMax) {
                // Mode-specific validation
                if (mode === 'aboveCost') {
                    if ((min <= srp) || (max <= srp)) {
                        return { aboveCostInvalid: true };
                    }
                }
                if (mode === 'aboveZero') {
                    if ((min <= 0) || (max <= 0)) {
                        return { aboveZeroInvalid: true };
                    }
                }
                // Generic min-max validation
                if (max < min) {
                    return { minMaxInvalid: true };
                }
            }
            return null;
        };
    };
    SrpMinMaxFormComponent.prototype.createRepairForm = function () {
        var _this = this;
        this.isLoading = true;
        var payload = { dealId: this.dealId, SRPForm: this.SRPCreateFrom.value };
        this.dealsService
            .stepSubmit(this.user._id, 'SRPForm', payload)
            .pipe(finalize(function () {
            _this.isLoading = false;
        }))
            .subscribe(function (response) {
            _this.isLoading = true;
            //console.log(response, 'response step 8');
            if (response && response.filename) {
                _this.SRPCreateFrom.markAsPristine();
                _this.SRPCreateFrom.reset();
                _this.isLoading = false;
                _this.activeModal.close(response);
                // this.dealsService.getDealById(
                //   this.user._id,
                //   this.dealId
                // );
                // this.dealsService.dealData$.subscribe((dealDatas:any) => {
                //   this.isLoading = false;
                //   this.activeModal.close(dealDatas);
                // })
            }
            else {
                _this.toastrService.warning('something went Wrong');
            }
        });
    };
    SrpMinMaxFormComponent.prototype.checkValidfields = function () {
        if (this.SRPCreateFrom.invalid || this.isLoading) {
            this.toastrService.warning('Please fill all required fields.');
            for (var i in this.SRPCreateFrom.controls) {
                this.SRPCreateFrom.controls[i].markAsTouched();
            }
        }
    };
    return SrpMinMaxFormComponent;
}());
export { SrpMinMaxFormComponent };
